import { createAction, props } from '@ngrx/store';
import { Reservation, Shift, TablesSection, AuditTrail, ReservationPurpose, ReservationStatus, SortType, ReservationListFilters, Table } from 'src/app/model/reservation';

export const loadReservations = createAction(
  '[ReservationList] Load Reservations'
);

export const autoLoadReservations = createAction(
  '[ReservationList] Auto Load Reservations'
);

export const loadReservationsSuccess = createAction(
  '[ReservationList] Load Reservations Success',
  props<{ reservations: Reservation[], shifts: Shift[] }>()
);

export const loadReservationsFailure = createAction(
  '[ReservationList] Load Reservations Failure',
  props<{ error: any }>()
);

export const setDate = createAction(
  '[ReservationList] Set Date',
  props<{ date: Date }>()
);

export const setEditingReservationId = createAction(
  '[ReservationList] Set Editing ReservationId',
  props<{ reservationId: string }>()
);

export const updateReservation = createAction(
  '[ReservationList] Update Reservation',
  props<{ reservation: Reservation }>()
);

export const setBlockingInterval = createAction(
  '[ReservationList] Set Blocking Interval',
  props<{ blockingInterval: string }>()
);

export const setBlockingPurpose = createAction(
  '[ReservationList] Set Blocking Purpose',
  props<{ blockingPurpose: ReservationPurpose }>()
);

export const setBlockingCategory = createAction(
  '[ReservationList] Set Blocking Category',
  props<{ blockingCategory: string }>()
);

export const setProcessedShifts = createAction(
  '[ReservationList] Set Processed Shifts',
  props<{ processedShifts: Shift[] }>()
);

export const setPendingReservations = createAction(
  '[ReservationList] Load Pending Reservations',
  props<{ reservations: Reservation[] }>()
);

export const addPendingReservation = createAction(
  '[ReservationList] Add Pending Reservation',
  props<{ reservation: Reservation }>()
);

export const addPendingReservationSuccess = createAction(
  '[ReservationList] Add Pending Reservation Success'
);

export const submitPendingReservation = createAction(
  '[ReservationList] Submit Pending Reservation'
);

export const submitPendingReservationSuccess = createAction(
  '[ReservationList] Submit Pending Reservation Success',
  props<{ reservation: Reservation }>()
);

export const submitPendingReservationFailure = createAction(
  '[ReservationList] Submit Pending Reservation Failure',
  props<{ error: any }>()
);

export const saveWorkingDateToLocalStorageSuccess = createAction(
  '[ReservationList] Save Working Date To Local Storage Success'
);

export const expandReservation = createAction(
  '[ReservationList] Expand Reservation',
  props<{ reservationId: string }>()
);

export const collapseReservation = createAction(
  '[ReservationList] Collapse Reservation',
  props<{ reservationId: string }>()
);

export const setGlobalSearchTerm = createAction(
  '[ReservationList] Set Global Search Term',
  props<{ term: string }>()
);

export const setSortType = createAction(
  '[ReservationList] Set Sort Type',
  props<{ sortType: SortType }>()
);

export const setSortDesc = createAction(
  '[ReservationList] Set Sort Desc',
  props<{ sortDesc: boolean }>()
);

export const setFilters = createAction(
  '[ReservationList] Set Filters',
  props<{ filters: ReservationListFilters }>()
);

export const setSelectedShift = createAction(
  '[ReservationList] Set Selected Shift',
  props<{ shift: Shift }>()
);

export const setOrderDetailsReservation = createAction(
  '[ReservationList] Set Order Details',
  props<{ reservationId: string }>()
);

// for offline usage
export const setCachedReservationsList = createAction(
  '[ReservationList] Set Cached Reservations List',
  props<{ lists: { date: Date, reservations: Reservation[] }[] }>()
);

export const clearCachedReservationsList = createAction(
  '[ReservationList] Clear Cached Reservations List'
);

export const setCompactView = createAction(
  '[App] Set Compact View',
  props<{ value: boolean }>()
);

export const setCompactViewSuccess = createAction(
  '[App] Set Compact View Success'
);

export const loadListFiltersAndSorting = createAction(
  '[ReservationList] Load List Filters And Sorting From Storage',
  props<{ filters: ReservationListFilters, sortType: SortType, sortDesc: boolean, selectedShift: Shift | null | undefined }>()
);

export const saveListFiltersAndSortingToStorageSuccess = createAction(
  '[ReservationList] Save List Filters And Sorting To Storage Success'
);

export const setReservationAllocatedTables = createAction(
  '[ReservationList] Set Reservation Allocated Tables',
  props<{ reservation: Reservation, tables: Table[] }>()
);

export const setScrollTop = createAction(
  '[ReservationList] Set Scroll Top',
  props<{ scrollTop:number }>()
);


